import type { LucideIcon } from 'lucide-react';
import { HelpTooltip } from './HelpTooltip';

interface Spec {
  label: string;
  icon?: LucideIcon;
  value: number | null | undefined;
  onChange: (v: number | null) => void;
  placeholder?: string;
  help?: string;
}

interface Props {
  specs: Spec[];
}

export default function SpecsBar({ specs }: Props) {
  return (
    <div className="flex bg-ui-bg border border-ui-border rounded divide-x divide-ui-border focus-within:border-ui-accent transition-colors">
      {specs.map((spec, i) => {
        const Icon = spec.icon;
        return (
          <div key={i} className="flex-1 flex flex-col items-center px-1.5 py-1.5 min-w-0">
            <span
              className="mb-1 flex min-h-5 items-center justify-center gap-1 text-center text-[10px] uppercase leading-tight tracking-wide text-ui-text-subtle"
              title={spec.label}
            >
              {Icon
                ? <Icon size={15} className="shrink-0" />
                : <span className="line-clamp-2">{spec.label}</span>
              }
              {spec.help && <HelpTooltip text={spec.help} />}
            </span>
            <input
              type="text"
              inputMode="numeric"
              value={spec.value ?? ''}
              onChange={(e) => {
                const raw = e.target.value.replace(/[^0-9]/g, '');
                spec.onChange(raw === '' ? null : Number(raw));
              }}
              placeholder={spec.placeholder ?? '—'}
              className="w-full bg-transparent text-center text-sm text-ui-text focus:outline-none placeholder:text-ui-text-subtle"
            />
          </div>
        );
      })}
    </div>
  );
}
